import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

const GetRtoCityLocation = () => {
    return axios
        .get(`${URL}/rtoCityLocation`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const PostRtoCityLocation = (recData) => {
    return axios
        .post(`${URL}/rtoCityLocation`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                ToastSuccess(res.message);
                return res;
            }
        })
        .catch((err) => {
            ToastError(err.response.data.message);
        });
};

const UpdateRtoCityLocation = (_id, recData) => {
    return axios
        .put(`${URL}/rtoCityLocation/${_id}`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                ToastSuccess(res.message);
                return res;
            }
        })
        .catch((err) => {
            ToastError(err.response.data.message);
        });
};

const DeleteRtoCityLocation = (id) => {
    return axios
        .delete(`${URL}/rtoCityLocation/${id}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message);
            } else {
                ToastSuccess(res.message);
                return res;
            }
        })
        .catch((err) => {
            ToastError(err.response.data.message);
        });
};

const FilterRtoCityLocation = (recData) => {
    return axios
        .post(`${URL}/rtoCityLocationFilter`, recData)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

export {
    GetRtoCityLocation,
    PostRtoCityLocation,
    UpdateRtoCityLocation,
    DeleteRtoCityLocation,
    FilterRtoCityLocation,
};
